import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Button from '@material-ui/core/Button';
import Select from "@material-ui/core/Select";
import { List, ListItemText, Link, ListItem } from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import TareasTerminadas from "../general/TareasTerminadas";
import { obtenerValoresFiltros, consulta } from "../../global/js/funciones";
import { ESTADOS_VALIDACIONES } from "./Helper";
import AppBarModal from "../general/AppBarModal";
import { BtnForm } from "../general/BotonesAccion";
import moment from "moment";
import emma_w from "../../global/imagenes/emma_w.png";
import { TextField } from "@material-ui/core";
import InputFile from "./../general/InputFile";
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import plantilla from "../../global/archivos/plantillas/reporte_icfes.xlsx";
import plantilla_id_terceros from "../../global/archivos/plantillas/id_terceros.xlsx";

class ReportesFiltrar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cargando: false,
      periodo: "",
      fecha_inicio: null,
      fecha_fin: null,
      cargar: true,
      periodos: [],
      modalidad: "",
      identificacion: "",
      unidadU:"",
      adj_icfes: '',
      corte: "",
      programa: "",
      programas: [],
      programa_solicitud: "",
      estado_solicitud: "",
      periodos_validaciones: [],
      estados_validacion: [],
      cargar_validaciones: true,

    };
    this.fileInput = React.createRef();
  }



  async componentDidUpdate({ modalFiltro }) {
    let { modalFiltro: modalFiltroNew, tipoReporte } = this.props;
    if (modalFiltro !== modalFiltroNew && modalFiltroNew && tipoReporte.codigo === "rep_hist_validaciones" && this.state.cargar_validaciones) {
      this.setState({ cargando: true });
      let [periodos_validaciones, estados_validacion] = await Promise.all([
        this.obtenerPeriodosValidaciones(),
        obtenerValoresFiltros([
          { llave: "generica", valor: ESTADOS_VALIDACIONES },
          { llave: "estado", valor: 1 },
        ]),
      ]);
      this.setState({
        periodos_validaciones,
        estados_validacion: estados_validacion || [],
        cargando: false,
        cargar_validaciones: false,
      });
    }
    if (modalFiltro !== modalFiltroNew && this.state.cargar) {
      this.setState({ cargando: true });
      let [periodos, programas] = await Promise.all([
        obtenerValoresFiltros([
          { llave: "generica", valor: 57 },
          { llave: "estado", valor: 1 },
        ]),
        obtenerValoresFiltros([
          { llave: "generica", valor: 5 },
          { llave: "estado", valor: 1 },
        ]),
      ]);
      this.setState({
        periodos,
        programas: programas || [],
        cargando: false,
        cargar: false,
      });
    }
  }



  obtenerPeriodosValidaciones = () => {
    return new Promise(resolve => {
      consulta(`api/v1.0/validaciones/periodos`, null, null, (error, estado, resp) => {
        resolve(estado === 200 && Array.isArray(resp) ? resp.filter(({ periodo }) => !!periodo) : []);
      });
    });
  };

  onChange = ({ target }) => {
    let { name, value, type, files } = target;
    if (type === 'file') {
      this.setState({ [name]: files && files[0] ? files[0] : '' });
    } else if (name === 'modalidad') {
      // Al cambiar la modalidad se limpia el programa para no enviar una unidad de otra modalidad
      this.setState({ modalidad: value, programa: '' });
    } else {
      this.setState({ [name]: value });
    }
  };

  setFechaInicio = (fecha_inicio) => {
    this.setState({
      fecha_inicio,
    });
  };
  setFechaFin = (fecha_fin) => {
    this.setState({
      fecha_fin,
    });
  };

  resetState = () => {
    let { mostrarModalFiltro } = this.props;
    this.setState({
      periodo: "",
      fecha_inicio: null,
      fecha_fin: null,
      modalidad: "",
      identificacion: "",
      adj_icfes: "",
      corte: "",
      programa: "",
      programa_solicitud: "",
      estado_solicitud: ""
    });
    mostrarModalFiltro(false);
  };

  programasDisponibles = () => {
    let { programas, modalidad } = this.state;
    if (!modalidad) return [];
    // Solo sirven los programas con codigo, que es el cod_unidad que espera el reporte
    let con_codigo = programas.filter(({ codigo }) => !!codigo);
    const mapa = { '1': ['pregrado', 'pregrado_virtual'], '2': ['posgrado', 'posgrado_virtual'] };
    const permitidos = mapa[modalidad];
    // Modalidad 3 (EDU.CONTINUA) no tiene valorc propio en la generica 5 -> se muestran todos
    if (!permitidos) return con_codigo;
    let filtrados = con_codigo.filter(({ valorc }) => permitidos.includes((valorc || '').toLowerCase()));
    return filtrados.length > 0 ? filtrados : con_codigo;
  };

  onSubmit = (e) => {
    let { setFiltros, mostrarModalReporte, actualizarMensaje, tipoReporte, codigo_gruporeporte } =
      this.props;
    let { periodo, fecha_inicio, fecha_fin, modalidad, identificacion, unidadU, adj_icfes, corte, programa, programa_solicitud, estado_solicitud } = this.state;

  //   let titulo = ''
  //   if(codigo_gruporeporte == 'grupo_admitido'){
  //     if(!periodo) titulo = 'Ingrese el periodo'
  //   }else if(codigo_gruporeporte == 'grupo_carga'){
  //     if(!periodo) titulo = 'Ingrese el periodo'
  //   }else if(codigo_gruporeporte == 'grupo_historico_notas'){
  //     if(!periodo) titulo = 'Ingrese el periodo'
  //   }else if(tipoReporte.codigo == 'rep_ac_icfes'){
  //     if(!identificacion) titulo = 'Ingrese la identificación'
  //   }else if(codigo_gruporeporte == 'grupo_inactivos'){
  //     if(!periodo) titulo = 'Ingrese el periodo'
      
  //     if(!modalidad) titulo= "Ingrese la modalidad"
  //   }else if(codigo_gruporeporte == 'grupo_matriculados' ){
  //     if(!periodo) titulo = 'Ingrese el periodo'
  //   }else if(codigo_gruporeporte == 'grupo_creditos'){
  //     if(!periodo) titulo= 'Ingrese el periodo'
  //     else if(!modalidad) titulo = 'Ingrese la modalidad'
  //   }else if(codigo_gruporeporte=='grupo_activos'){
  //     if(!periodo) titulo= "Ingrese el periodo"
  //     else if(!modalidad) titulo= "Ingrese la modalidad"
  //   }else if (tipoReporte.codigo=='rep_canceladas' || 'rep_no_aprobadas' ){
  //     if(!periodo) titulo= "Ingrese el periodo"
  //   }else if (tipoReporte.codigo=='rep_tomadas'){
  //   if(!periodo) titulo= "Ingrese el periodo"
  //   if(!modalidad) titulo= "Ingrese la modalidad"
  // }
  let titulo = '';
const GRUPO_ADMITIDO = 'grupo_admitido';
const GRUPO_CARGA = 'grupo_carga';
const GRUPO_HISTORICO_NOTAS = 'grupo_historico_notas';
const GRUPO_INACTIVOS = 'grupo_inactivos';
const GRUPO_MATRICULADOS = 'grupo_matriculados';
const GRUPO_CREDITOS = 'grupo_creditos';
const GRUPO_ACTIVOS = 'grupo_activos';
const REP_AC_ICFES = 'rep_ac_icfes';
const REP_ID_TERCERO = 'rep_id_tercero';
const REP_CANCELADAS = 'rep_canceladas';
const REP_NO_APROBADAS = 'rep_no_aprobadas';
const REP_TOMADAS = 'rep_tomadas';
const REP_SEMAFORO ='rep_semaforo';
const REP_PROMEDIO = 'reporte_promedio_acumulado';
const REP_MAT_FINAN_PREGRADO = 'rep_mat_finan_pregrado';
const REP_MAT_INGLES = 'rep_mat_ingles';
const GRUPO_HEP = 'grupo_hep';
const REP_HISTORIA_ACADEMICA = 'rep_historia_academica';
const REP_PAG_DERECHO ='rep_pag';
const REP_NOTAS_CORTE = 'rep_notas_corte';
const REP_HIST_VALIDACIONES = 'rep_hist_validaciones';

// La validacion de rep_notas_corte va primero: la rama del grupo grupo_historico_notas
// solo exige el periodo y dejaria pasar modalidad y corte vacios.
if (tipoReporte.codigo === REP_NOTAS_CORTE) {
  if (!periodo) titulo = 'INGRESE EL PERIODO';
  else if (!/^[0-9]{5,6}$/.test(periodo.trim())) titulo = 'INGRESE UN PERIODO VÁLIDO (FORMATO: AAAAS, EJ: 20262)';
  else if (!modalidad) titulo = 'SELECCIONE LA MODALIDAD';
  else if (!corte) titulo = 'SELECCIONE EL CORTE';
  else periodo = periodo.trim().toUpperCase();
} else if (tipoReporte.codigo === REP_HIST_VALIDACIONES) {
  // Todos los filtros son opcionales: sin filtros trae el historico completo
} else if(codigo_gruporeporte === GRUPO_ADMITIDO || codigo_gruporeporte === GRUPO_CARGA || codigo_gruporeporte === GRUPO_HISTORICO_NOTAS) {
  if(!periodo) titulo = 'INGRESE EL PERIODO';
} else if(tipoReporte.codigo === REP_AC_ICFES || tipoReporte.codigo === REP_ID_TERCERO) {
  if(!adj_icfes) titulo = 'CARGUE LA PLANTILLA';
} else if(codigo_gruporeporte === GRUPO_INACTIVOS) {
  if (codigo_gruporeporte === GRUPO_INACTIVOS) {
    if (!periodo || !periodo.toUpperCase()) {
      titulo = 'INGRESE EL PERIODO';
    } else {
      periodo = periodo.toUpperCase();
    }
    if (!modalidad) {
      titulo = 'INGRESE LA MODALIDAD';
    }
  }
  
} else if(codigo_gruporeporte === GRUPO_MATRICULADOS) {
  if(!periodo) titulo = 'INGRESE EL PERIODO';
} else if(codigo_gruporeporte === GRUPO_CREDITOS) {
  if(!periodo) titulo = 'INGRESE EL PERIODO';
  else if(!modalidad) titulo = 'INGRESE LA MODALIDAD';
} else if(codigo_gruporeporte === GRUPO_ACTIVOS) {
  if(!periodo) titulo = 'INGRESE EL PERIODO';
  else if(!modalidad) titulo = 'INGRESE LA MODALIDAD';
} else if (tipoReporte.codigo === REP_CANCELADAS || tipoReporte.codigo === REP_NO_APROBADAS) {
  if(!periodo) titulo = 'INGRESE EL PERIODO';
} else if (tipoReporte.codigo === REP_TOMADAS) {
  if(!periodo) titulo = 'INGRESE EL PERIODO';
  if(!modalidad) titulo = 'INGRESE LA MODALIDAD';
} else if(tipoReporte.codigo===REP_SEMAFORO) {
  if(!periodo) titulo = 'INGRESE EL PERIODO';
} else if(tipoReporte.codigo===REP_PROMEDIO) {
  if (!periodo || !periodo.toUpperCase()) {
      titulo = 'INGRESE EL PERIODO';
      periodo = periodo.toUpperCase();
    } else {
      if (!modalidad) {
        titulo = 'INGRESE LA MODALIDAD';
    }
    
    }
  } else if(tipoReporte.codigo===REP_HISTORIA_ACADEMICA) {
    if (!periodo || !periodo.toUpperCase()) {
        titulo = 'INGRESE EL PERIODO';
        periodo = periodo.toUpperCase();
      } else {
        if (!modalidad) {
          titulo = 'INGRESE LA MODALIDAD';
      }
      
      }
    } else if(codigo_gruporeporte === GRUPO_HEP) {
      if(!periodo) titulo = 'INGRESE EL PERIODO'; 
    } else if (tipoReporte.codigo=== REP_MAT_FINAN_PREGRADO){
      if (!periodo || !/^[0-9]{5}$/.test(periodo) || parseInt(periodo) < 20051 || parseInt(periodo) > 20232 || /[3-9]$/.test(periodo) || !/[0-4,6-9]/.test(periodo)) {
        titulo = 'INGRESE UN PERIODO VÁLIDO (FORMATO: AAAAS) Y DEBE ESTAR ENTRE 20051 - 20232, EXCEPTO PERIODOS TERMINADOS EN 3-9 Y QUE CONTENGAN EL CARÁCTER 5';
      } else {
        periodo = periodo.toUpperCase();
        if (!unidadU) {
          titulo = 'INGRESE LA UNIDAD';
        }
      }
      } else if (tipoReporte.codigo=== REP_MAT_INGLES){
        if (!periodo || !periodo.toUpperCase()) {
          titulo = 'INGRESE EL PERIODO';
          periodo = periodo.toUpperCase();
        } else {
          if (!modalidad) {
            titulo = 'INGRESE LA MODALIDAD';
          }
        }
        
    }else if(tipoReporte.codigo===REP_PAG_DERECHO) {
}else if(tipoReporte.codigo===REP_PAG_DERECHO) {
  if(!fecha_inicio) titulo = 'INGRESE FECHA INICIAL';
}




    // if (!fecha_inicio && tipoReporte.valorb)
    //   actualizarMensaje({
    //     titulo: "Seleccione la fecha Inicial.",
    //     tipo: "info",
    //     mostrar: true,
    //     tiempo: 6000,
    //   });
    // else if (!periodo && !fecha_inicio )
    //   actualizarMensaje({
    //     titulo: "Escribe el Periodo.", // se cambio el seleccione por escribe 
    //     tipo: "info",
    //     mostrar: true,
    //     tiempo: 6000,
    //   });
    // else if (!modalidad && tipoReporte.valorc === "grupo_matriculados")
    //   actualizarMensaje({
    //     titulo: "Seleccione la Modalidad.",
    //     tipo: "info",
    //     mostrar: true,
    //     tiempo: 6000,
    //   });
    // else if (!modalidad && tipoReporte.codigo === "rep_matriculados")
    //   actualizarMensaje({
    //     titulo: "Seleccione la Modalidad.",
    //     tipo: "info",
    //     mostrar: true,
    //     tiempo: 6000,
    //   });
    // else if (!identificacion && tipoReporte.codigo === "rep_ac_icfes" && periodo ==="")
    //   actualizarMensaje({
    //     titulo: "Digite el numero de identificacion del estudiante.",
    //     tipo: "info",
    //     mostrar: true,
    //     tiempo: 6000,
    //   });
    // else {
    //   fecha_inicio = fecha_inicio
    //     ? moment(fecha_inicio).format("DD/MM/YYYY")
    //     : null;
    //   fecha_fin = fecha_fin ? moment(fecha_fin).format("DD/MM/YYYY") : null;

    // }
  
  
  

    if(titulo){
      actualizarMensaje({titulo ,tipo: "info",
            mostrar: true,
            tiempo: 6000,
          });
    }else{
      let unidad=unidadU.toUpperCase()
      fecha_inicio = fecha_inicio
        ? moment(fecha_inicio).format("DD/MM/YYYY")
        : null;
      fecha_fin = fecha_fin ? moment(fecha_fin).format("DD/MM/YYYY") : null;
      if (adj_icfes && adj_icfes instanceof File) {
      } else if (adj_icfes) {
        adj_icfes = document.getElementById('adj_icfes') && document.getElementById('adj_icfes').files ? document.getElementById('adj_icfes').files[0] : adj_icfes;
      }
      let data = { periodo, fecha_inicio, fecha_fin, modalidad, identificacion, unidad, adj_icfes, archivo: adj_icfes, corte: corte || '', programa: programa || '', programa_solicitud: programa_solicitud || '', estado_solicitud: estado_solicitud || '' };
      setFiltros(data);
      mostrarModalReporte(true);
      this.resetState();
    }
    e.preventDefault();
  };

  render() {
    let { modalFiltro, mostrarModalFiltro, tipoReporte, codigo_gruporeporte } = this.props;
    let { periodo, fecha_inicio, fecha_fin, periodos, tipo, modalidad, cargando, unidadU, adj_icfes, corte, programa, programas, programa_solicitud, estado_solicitud, periodos_validaciones, estados_validacion } =
      this.state;

    return (
      <Dialog
        open={modalFiltro}
        onClose={() => mostrarModalFiltro(false)}
        fullWidth={true}
        maxWidth="sm"
        aria-labelledby="form-dialog-title"
      >
        <AppBarModal
          titulo="! Aplicar Filtros ¡"
          mostrarModal={mostrarModalFiltro}
          titulo_accion=""
          accion=""
        />
        <DialogContent className="scroll">
          {cargando ? (
            <TareasTerminadas
              mensaje="Cargando.."
              marginTop="7%"
              imagen={emma_w}
              widthImg="7%"
              cargando={true}
            />
          ) : (
            <Grid container spacing={3} className="margin_cont">
              <Grid item xs={12} className='oculto'>
                <TextField
                  ref={this.fileInput}
                  required
                  type="file"
                  id="adj_icfes"
                  name="adj_icfes"
                  label="Adjuntar Plantilla"
                  fullWidth
                  autoComplete="billing address-line1"
                  onChange={this.onChange}
                />
              </Grid>


      {!tipoReporte.valorb && tipoReporte.codigo !== "rep_ac_icfes" &&
      tipoReporte.codigo !== "rep_id_tercero" && tipoReporte.codigo !== "rep_hist_validaciones" && (
                    <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    {/* <Select
                      inputProps={{
                        name: "periodo",
                        id: "periodo",
                      }}
                      value={periodo}
                      onChange={this.onChange}
                      required={true}
                    >
                      {periodos.map(({ id, nombre }) => (
                        <MenuItem key={id} value={nombre}>
                          {nombre}
                        </MenuItem>
                      ))}
                    </Select>  */}
                    
                      <TextField
                        label="Periodo"
                        id="periodo"
                        name="periodo"
                        value={periodo.toUpperCase()}
                        onChange={this.onChange}
                        required={true}
                        

                      />
                  </FormControl>
                </Grid>
              )}
              {tipoReporte.codigo == "rep_pag" && (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      id="date-picker-dialog"
                      label="Fecha Inicio"
                      format="dd-MM-yyyy"
                      value={fecha_inicio}
                      onChange={this.setFechaInicio}
                      style={{ width: "100%" }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      invalidDateMessage="Formato Invalido"
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              )}
              {/* {tipoReporte.codigo == "rep_ingles" &&(
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                      <MenuItem key={3} value={"3"}>
                        EDUCACIÓN CONTINUADA
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

              )} */}

              

              {tipoReporte.codigo === "rep_inactivos" &&  (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                        
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                      

                      
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                      
                    </Select>
                  </FormControl>
                </Grid>
                
                 )}

                {tipoReporte.codigo === "reporte_promedio_acumulado" &&  (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                 )}

            {tipoReporte.codigo === "rep_historia_academica" &&  (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                 )}
                 {tipoReporte.codigo === "rep_hist_notas" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem> 
                    </Select>
                  </FormControl>
                </Grid>
                 )}
                 
                 {tipoReporte.codigo === "rep_activos" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                      
                    </Select>
                  </FormControl>
                </Grid>
                 )}
                 {tipoReporte.codigo === "rep_tomadas" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                      
                    </Select>
                  </FormControl>
                </Grid>
                 )}

          {tipoReporte.codigo === "rep_definitivas" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                      
                    </Select>
                  </FormControl>
                </Grid>
                 )}

              {tipoReporte.codigo === "rep_notas_corte" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                      <MenuItem key={3} value={"3"}>
                        EDU.CONTINUA
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {tipoReporte.codigo === "rep_notas_corte" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="corte">
                      Seleccione el Corte
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "corte",
                        id: "corte",
                      }}
                      value={corte}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"PRIMER CORTE"}>
                        PRIMER CORTE
                      </MenuItem>
                      <MenuItem key={2} value={"SEGUNDO CORTE"}>
                        SEGUNDO CORTE
                      </MenuItem>
                      <MenuItem key={3} value={"TERCER CORTE"}>
                        TERCER CORTE
                      </MenuItem>
                      <MenuItem key={4} value={"CUARTO CORTE"}>
                        CUARTO CORTE
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {tipoReporte.codigo === "rep_notas_corte" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="programa" shrink>
                      Programa (opcional)
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "programa",
                        id: "programa",
                      }}
                      value={programa}
                      onChange={this.onChange}
                      displayEmpty
                      disabled={!modalidad}
                    >
                      <MenuItem key={"todos"} value={""}>
                        TODOS LOS PROGRAMAS
                      </MenuItem>
                      {this.programasDisponibles().map(({ id, codigo, nombre }) => (
                        <MenuItem key={id} value={codigo}>
                          {nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {tipoReporte.codigo === "rep_hist_validaciones" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="periodo" shrink>
                      Periodo (opcional)
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "periodo",
                        id: "periodo",
                      }}
                      value={periodo}
                      onChange={this.onChange}
                      displayEmpty
                    >
                      <MenuItem key={"todos"} value={""}>
                        TODOS LOS PERIODOS
                      </MenuItem>
                      {periodos_validaciones.map(({ periodo: valor_periodo }) => (
                        <MenuItem key={valor_periodo} value={valor_periodo}>
                          {valor_periodo}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {tipoReporte.codigo === "rep_hist_validaciones" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="programa_solicitud" shrink>
                      Programa (opcional)
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "programa_solicitud",
                        id: "programa_solicitud",
                      }}
                      value={programa_solicitud}
                      onChange={this.onChange}
                      displayEmpty
                    >
                      <MenuItem key={"todos"} value={""}>
                        TODOS LOS PROGRAMAS
                      </MenuItem>
                      {programas.map(({ id, nombre }) => (
                        <MenuItem key={id} value={id}>
                          {nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {tipoReporte.codigo === "rep_hist_validaciones" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="estado_solicitud" shrink>
                      Estado de la solicitud (opcional)
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "estado_solicitud",
                        id: "estado_solicitud",
                      }}
                      value={estado_solicitud}
                      onChange={this.onChange}
                      displayEmpty
                    >
                      <MenuItem key={"todos"} value={""}>
                        TODOS LOS ESTADOS
                      </MenuItem>
                      {estados_validacion.map(({ id, nombre }) => (
                        <MenuItem key={id} value={id}>
                          {nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {tipoReporte.codigo === "rep_semaforo" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                      
                    </Select>
                  </FormControl>
                </Grid>
                 )}
                   
  {(tipoReporte.codigo === "rep_ac_icfes" || tipoReporte.codigo === "rep_id_tercero") && (                  
  <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                    <Grid container >
                      <Grid item xs={12} md={12} className={`alert_info_titulo`}>
                        <Button variant="text" size="small" color="inherit" >
                          <NotificationImportantIcon style={{ height: 15 }} /> Nota</Button>
                      </Grid>
                      <Grid item xs={12} md={12} className={`alert_info`}>
                        <Grid>
                          Tenga en cuenta las siguientes indicaciones:
                          <List dense={true}>
                            <ListItem>
                              <ListItemText primary={<Link href={tipoReporte.codigo === "rep_id_tercero" ? plantilla_id_terceros : plantilla} target="_blank" underline='none' download={tipoReporte.codigo === "rep_id_tercero" ? "id_terceros.xlsx" : "reporte_icfes.xlsx"}>Descargue esta plantilla y anexe los datos.</Link>} />
                            </ListItem>
                            <ListItem>
                              <ListItemText primary={'No realice cambios en el formato de la plantilla.'} />
                            </ListItem>
                          </List>
                        </Grid>
                      </Grid>
                    </Grid>
                    <InputFile label='Adjuntar Plantilla' id='adj_icfes' value={adj_icfes ? adj_icfes.name : ""} required={true} />
                  </Grid>
              )}

              {tipoReporte.codigo === "rep_mat_finan_pregrado" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                  
                    <TextField
                      label="unidad"
                      id="unidadU"
                      name="unidadU"
                      value={unidadU}
                      onChange={this.onChange}
                      required={true}

                    />


                  </FormControl>
                </Grid>
              
              )}

      

              {tipoReporte.codigo ==  "rep_matriculados" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                      <MenuItem key={3} value={"3"}>
                        INGLES
                      </MenuItem>
                      <MenuItem key={4} value={"4"}>
                        CURSOS LIBRES
                      </MenuItem>
                      <MenuItem key={5} value={"5"}>
                        DIPLOMADO
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                
                
              )}

        {tipoReporte.codigo ===  "rep_matricula_academica" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                      <MenuItem key={3} value={"3"}>
                        MAESTRIAS
                      </MenuItem>
                      <MenuItem key={4} value={"4"}>
                        INTERSEMESTRALES
                      </MenuItem>
                    
                    </Select>
                  </FormControl>
                </Grid>

                
                
              )}

        {tipoReporte.codigo ===  "rep_mat_ingles" && (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                      <MenuItem key={3} value={"3"}>
                        INGLES
                      </MenuItem>
                    
                    </Select>
                  </FormControl>
                </Grid>

                
                
              )}

                
            
     {tipoReporte.codigo ==  "rep_creditos_cursados" || tipoReporte.codigo ==  "rep_creditos_aprobados"  ? (
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="modalidad">
                      Seleccione la Modalidad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "modalidad",
                        id: "modalidad",
                      }}
                      value={modalidad}
                      onChange={this.onChange}
                      required={true}
                    >
                      <MenuItem key={1} value={"1"}>
                        PREGRADO
                      </MenuItem>
                      <MenuItem key={2} value={"2"}>
                        POSGRADO
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
   ) : ''}               
              {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} >
                <KeyboardDatePicker
                  minDate={fecha_inicio}
                  id="date-picker-dialog"
                  label="Fecha Fin"
                  format="dd-MM-yyyy"
                  value={fecha_fin}
                  onChange={this.setFechaFin}
                  style={{ width: '100%' }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  minDateMessage={`La fecha fin no puede ser menor que la fecha inicio.`}
                  invalidDateMessage='Formato Invalido'
                />
              </MuiPickersUtilsProvider>
            </Grid> */}


            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <BtnForm
            texto="CANCELAR"
            callback={() => mostrarModalFiltro(false)}
          />
          {!cargando && <BtnForm texto="CONSULTAR" callback={this.onSubmit} />}
        </DialogActions>
      </Dialog>
    );
  }
}

export default ReportesFiltrar;
